import React from "react";
// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import Table from '../widgets/tables/Table';
import Loading from "../components/Loading";
import moment from "moment";
import checkToken from "../services/checkToken";
import getOrdiniFornitori from "../services/getOrdiniFornitori";
import deleteOrdineFornitore from "../services/deleteOrdineFornitore";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });
export default class OrdiniFornitori extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      isLoading: true
    };

  }

  async reload() {
    this.setState({ isLoading: true });

    username = cookies.get('username', { path: '/' });
    token = cookies.get('token', { path: '/' });

    const check = await checkToken(username, token, true);
    const userType = parseInt(check.utente.tipo);

    let editOrdiniFornitoriLink = '';

    this.ordiniFornitori = await getOrdiniFornitori(username, token);

    switch (userType) {
      case 0:
        editOrdiniFornitoriLink = '/#/app/edit-ordine-fornitore';
        break;
      case 1:
        editOrdiniFornitoriLink = '/#/tecnico/edit-ordinr-fornitore';
        break;
      case 3:
        editOrdiniFornitoriLink = '/#/commerciale/edit-ordine-fornitore';
        break;
      case 4:
        editOrdiniFornitoriLink = '/#/service/edit-ordine-fornitore';
        break;
      default:
        break;
    }

    this.ordiniFornitori.forEach((ordine, index) => {
      this.ordiniFornitori[index].data_ordine = moment(ordine.data_ordine, 'yyyy-MM-DD HH:mm:ss').format('DD/MM/yyyy');
      this.ordiniFornitori[index].stato = ordine.concluso === '1' ? "Concluso" : ordine.concluso_magazzino === '1' ? 'Concluso magazzino' : "In Corso";
    })

    this.setState({ isLoading: false, isUserType: userType, editOrdiniFornitoriLink: editOrdiniFornitoriLink });
  }

  async delete(row) {
    if (window.confirm('Sei davvero sicuro di volere eliminare quest\'ordine?')) {
      const res = await deleteOrdineFornitore(username, token, row);
      if (res.result === 'ok') {
        window.location.reload();
        return;
      }

      alert('Errore nella cancellazione dell\'ordine');
    }
  }

  async componentDidMount() {
    await this.reload();
  }


  render() {

    if (this.state.isLoading)
      return <Loading />;

    const cookies = new Cookies();

    var headCells = [
      { id: 'rif', numeric: false, disablePadding: true, label: 'Riferimento' },
      { id: 'ragione_sociale', numeric: true, disablePadding: false, label: 'Fornitore' },
      { id: 'totale', numeric: true, disablePadding: false, label: 'Importo Totale' },
      { id: 'data_ordine', numeric: true, disablePadding: false, label: 'Data Ordine' },
      { id: 'stato', numeric: true, disablePadding: false, label: 'Stato', chip: true },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];

    this.searchCols = ['rif', 'fornitore', 'stato', 'data_ordine'];

    return (
      <div id={Math.random()}>

        {
          this.state.isUserType === 4 && <PageTitle title="Ordini Fornitori" button="AGGIUNGI"
            onClick={() => {
              window.location.href = '/#/service/add-ordine-fornitore';
            }}
          />
        }

        {
          this.state.isUserType !== 4 && <PageTitle title="Ordini Fornitori" />
        }


        <Table headCells={headCells} searchCols={this.searchCols} rows={this.ordiniFornitori} order={'desc'}
          onEventClick={(row) => {
            cookies.set('ordineFornitore', row, { path: '/' });
            window.location.href = this.state.editOrdiniFornitoriLink;
          }}
          onDelete={this.state.isUserType === 0 ? this.delete.bind(this) : null}
        />
      </div>
    );
  }
}

